import React from 'react';
import PropTypes from 'prop-types';

/**
*/
export default function NuovoQuestitoTitle({ avvisaScadenza, codiceUfficio }) {
  return (
    <div className="helpdesk-frontend-modale__titolo">
      <div>Crea nuovo quesito</div>
    </div>
  );
}

NuovoQuestitoTitle.propTypes = {
  avvisaScadenza: PropTypes.bool.isRequired,
  codiceUfficio: PropTypes.string,
};

NuovoQuestitoTitle.defaultProps = {
  codiceUfficio: undefined,
};
